// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactDOMStyle from "@rescript/react/src/ReactDOMStyle.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import ButtonMenuModuleCss from "./ButtonMenu.module.css";

let classes = ButtonMenuModuleCss;

function ButtonMenu(props) {
  let nodeId = React.useId().slice(1, -1);
  let popoverId = `popover-` + nodeId;
  let anchorId = `anchor-` + nodeId;
  let anchorName = `--button-menu-` + nodeId;
  return <>
    {React.cloneElement(<button
      className={props.className}
      id={anchorId}
      style={ReactDOMStyle.unsafeAddProp({}, "anchorName", anchorName)}
      title={props.title}
      type={"button"}
    >
      {props.children}
    </button>, {
      popoverTarget: popoverId,
      popoverTargetAction: "toggle"
    })}
    {React.cloneElement(<div
      className={classes.popover}
      id={popoverId}
      style={ReactDOMStyle.unsafeAddProp({}, "positionAnchor", anchorName)}
    >
      <nav>
        <ul>
          {props.menuItems.map((item, idx) => <li
            key={idx.toString()} >
            <button
              disabled={Stdlib_Option.getOr(item.disabled, false)}
              type={"button"}
              onClick={item.onClick}
            >
              {item.label}
            </button>
          </li>)}
        </ul>
      </nav>
    </div>, {
      popover: ""
    })}
  </>;
}

let make = ButtonMenu;

export {
  classes,
  make,
}
/* classes Not a pure module */
